import { render, staticRenderFns } from "./BCOptionalFeaturesDataHold.vue?vue&type=template&id=b3684b38"
import script from "./BCOptionalFeaturesDataHold.vue?vue&type=script&lang=js"
export * from "./BCOptionalFeaturesDataHold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports